module.exports = __webpack_public_path__ + "static/img/bg.8c2849d0.jpg";